import { render, staticRenderFns } from "./SubscribeDiaspora.vue?vue&type=template&id=941f864e&scoped=true&"
import script from "./SubscribeDiaspora.vue?vue&type=script&lang=js&"
export * from "./SubscribeDiaspora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941f864e",
  null
  
)

export default component.exports